import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import { type HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'

export class GetSubscriberFiltersQuery extends GetNetworkQuery {
  constructor(private readonly organization: string) {
    super(ApiEndpoint.SubscriberFilters)
  }

  public get queryParameters(): HttpParameters {
    return {
      organization: this.organization
    }
  }
}
